import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { Field } from "@base-ui/react/field";
import css from "./DateInput.module.css";

const DateInput = React.forwardRef(
  (
    {
      bare = false,
      type = "date",
      value,
      onValueChange,
      min,
      max,
      label,
      description,
      error,
      disabled = false,
      required = false,
      name,
      className,
      ...rest
    },
    ref,
  ) => {
    const hasError = Boolean(error);

    const handleChange = onValueChange
      ? (e) => onValueChange(e.target.value)
      : undefined;

    if (bare) {
      return (
        <Field.Control
          ref={ref}
          type={type}
          className={css.input}
          name={name}
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          required={required}
          disabled={disabled}
          {...rest}
        />
      );
    }

    return (
      <Field.Root
        className={clsx(css.root, className)}
        disabled={disabled}
        invalid={hasError}
      >
        {label && <Field.Label className={css.label}>{label}</Field.Label>}
        <Field.Control
          ref={ref}
          type={type}
          className={css.input}
          name={name}
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          required={required}
          {...rest}
        />
        {description && !hasError && (
          <Field.Description className={css.description}>
            {description}
          </Field.Description>
        )}
        {typeof error === "string" && (
          <Field.Error className={css.error} match>
            {error}
          </Field.Error>
        )}
      </Field.Root>
    );
  },
);

DateInput.displayName = "DateInput";

DateInput.propTypes = {
  bare: PropTypes.bool,
  type: PropTypes.oneOf(["date", "datetime-local", "time", "month", "week"]),
  value: PropTypes.string,
  onValueChange: PropTypes.func,
  min: PropTypes.string,
  max: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
  className: PropTypes.string,
};

export default DateInput;
